import { IconProps } from "../../types/icon";

export default function ReplayIcon({
  size = 24,
  color = "currentColor",
  ...props
}: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 57 51"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M41.8748 43.5034C37.4811 47.508 31.6381 49.9497 25.2248 49.9497C11.5697 49.9497 0.5 38.88 0.5 25.2248C0.5 11.5697 11.5697 0.5 25.2248 0.5C31.3982 0.5 37.0431 2.76245 41.3756 6.50342C45.3693 9.9518 48.2478 14.6565 49.3973 20.0034"
        stroke={color}
        strokeMiterlimit="10"
        strokeLinecap="round"
      ></path>
      <path
        d="M55.9395 4.00342L49.4761 20.3348L32.2014 18.8577"
        stroke={color}
        strokeLinecap="round"
      ></path>
    </svg>
  );
}
